import React from 'react';
import Video_title from '../../../../../component/Video_title';
import VideoThumbnailCard from '../../../../components/VideoThumbnailCard';
import NoVideosFoundSection from '../../../../components/NoVideosFoundSection';

const VideoGrid = ({
	category,
	handleShuffle,
	isLoggedIn,
	handlePlayerVideo,
	handleAddToPlaylist,
	handleSaveVideo,
	savedVideoIds,
	selectedTags,
	setSelectedTags,
	modal,
	setModal,
	setVideoData,
	selectTagCallback
}) => {
	return (
		<div className="c-video">
			<div className="row c-video_textrow c-video_list pb-0">
				<div className="col-md-8 c-video_textcol c-mobile_videotext-1">
					<h4>{category?.name}</h4>
				</div>
				<div className="col-md-4 c-video_textcol-a text-end c-mobile_videotext-2">
					<a onClick={() => handleShuffle(category?.id)}>
						<span style={{ color: '#3cb4e4' }}>
							<i className="fa-solid fa-shuffle"></i>
						</span>
						<span style={{ color: '#3cb4e4' }}>Shuffle</span>
					</a>
				</div>
			</div>
			{category?.videos?.length === 0 && (
				<NoVideosFoundSection />
			)}
			<div className="c-video_list">
				<div className="row m-0">
					{category?.videos?.map((video, index) => (
						<div key={index} className="mb-2">
							<VideoThumbnailCard
								key={index}
								content={video}
								isLoggedIn={isLoggedIn}
								handlePlayerVideo={handlePlayerVideo}
								handelSubmitPlaylist={handleAddToPlaylist}
								handleSaveUnsave={handleSaveVideo}
								savedVideos={savedVideoIds}
								modal={modal}
								setModal={setModal}
								setVideoData={setVideoData}
								titleStyles={{ fontSize: 'clamp(1.15rem, 1.2vw, 1.6rem)' }}
								selectTagCallback={selectTagCallback}
								selectedTags={selectedTags}
							/>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

// Further breakdown of VideoTitle component
const VideoTitle = ({ video, handlePlayerVideo, selectedTags, setSelectedTags }) => {
	const videoId = video?.videoDetails?._id || video?._id;

	// Handle video details or direct video data
	const title = video?.videoDetails?.title || video?.title || '';

	const tags = video?.videoDetails?.tagsDetails || video?.tagsDetails || [];
	const sortedTags = [...tags]
		.map(tag => ({
			_id: tag._id,
			name: tag.name,
			color: tag.color,
			priority: tag?.priority || 0
		}))
		.sort((a, b) => a?.priority - b?.priority);

	const releaseDate = video?.videoDetails?.releaseDateTime || video?.releaseDateTime || '';

	const selectTagCallback = tag => {
		setSelectedTags(prevTags => {
			if (prevTags.includes(tag._id)) {
				return prevTags.filter(t => t !== tag._id);
			}
			return [...prevTags, tag._id];
		});
	};

	return (
		<Video_title
			title={title}
			tags={sortedTags}
			releaseDate={releaseDate}
			onClick={() => handlePlayerVideo(videoId)}
			selectedTags={selectedTags}
			selectTagCallback={selectTagCallback}
		/>
	);
};

export default VideoGrid;
